import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: "ttdateago"
})

export class TTDateAgoPipe implements PipeTransform {
    transform(value: any[], args?: any): any {
        if (!value) {
            return '';
        }
        var m = moment(value);
        return m.fromNow();
    }
}

@Pipe({
    name: "ttdateformat"
})

export class TTDateFormatPipe implements PipeTransform {
    transform(value: any[], args?: any): any {
        if (!value) {
            return '';
        }
        var m = moment(value);
        return m.format('DD/MM/YYYY hh:mm:ss A');
    }
}

@Pipe({
    name: "ttdateformat2"
})

export class TTDateFormatPipe2 implements PipeTransform {
    transform(value: any[], args?: any): any {
        if (!value) {
            return '';
        }
        var m = moment(value);
        return m.format("DD MMM’YY hh:mm:ss A");
    }
}

@Pipe({
    name: "ttboolformat"
})

export class TTBoolFormatPipe implements PipeTransform {
    transform(value: any[], args: any): any {
        return value ? 'Yes' : 'No';
    }
}